import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Layout from "../../components/layout";
import Breadcrumb from "§/src/components/atoms/breadcrumb/breadcrumb"
import SchemaBreadcrumb from "§/src/components/schema/s-breadcrumb"

import SEO from "../../components/seo";

// Atoms
import RelatedProductsWithVideo from "§/src/components/sections/related-products-with-video"
import TextModule from "§/src/components/atoms/content/text-module"
const CaseHistoryCarousel = React.lazy(() =>
  import("§/src/components/sections/case-history-carousel")
)
import ButtonEdgeRounded from "§/src/components/atoms/buttons/button-edge-rounded"

// Swiper
import { Swiper, SwiperSlide } from "swiper/react"
import { Pagination, Navigation } from "swiper"
import "swiper/css/free-mode"

// Switch Language
import { useTranslation } from "react-i18next"
import { getFormattedLanguage } from "§/src/utils/functions"

// Internals
import "./_style.scss"

import { graphql } from "gatsby"

export function Head(props) {
  const seo = props?.pageContext?.seo || {}

  return (
    <React.Fragment>
      <html lang={getFormattedLanguage(process.env.GATSBY_SITE_LANG)}></html>
      <body className="page technology"></body>
      <SEO seo={seo} translations={props?.data?.lang?.translations}/>
      <SchemaBreadcrumb breadcrumbs={seo?.breadcrumbs} />
    </React.Fragment>
  )
}


const PageTemplate = props => {
  const { t } = useTranslation()

  const pageContext = props?.pageContext
  const data = pageContext?.acfPages_technology
  const images = data?.gallery
  
  const otherChildrenData = props?.data?.childPages?.nodes[0]?.wpChildren?.nodes?.filter(val => val?.title !== pageContext?.title)

  const sliderId = "gallery-sw"

  return (
    <Layout lang={props?.data?.lang?.translations}>
      <Breadcrumb wpseo={pageContext?.seo?.breadcrumbs} />
      <React.Suspense>
        {data?.compVideo &&
          data?.compVideo[0] && (
          <RelatedProductsWithVideo
            video={data?.compVideo[0]}
            products={data?.relatedProducts}
          />)
        }

        <TextModule
          title= {data?.contentFirstTitle}
          content = {data?.contentFirstContent}
          className={"pb-0 pb-md-7 pt-3 pt-md-7 pt-md-0"}
        />
        
        <Swiper
          slidesPerView={1.05}
          spaceBetween={10}
          freeMode={true}
          loop={false}
          breakpoints={{
            576: {
              slidesPerView: 1.3,
              spaceBetween: 20
            }
          }}
          navigation={{
            nextEl: "#" + sliderId + "-nav-next",
            prevEl: "#" + sliderId + "-nav-prev",
          }}
          pagination={false}
          modules={[Pagination, Navigation]}
          className="pt-7 pb-md-7 gallery-swiper"
        >
          {images?.map((img, i) => (
            <SwiperSlide key={i}>
              <GatsbyImage
                className="sw-image"
                image={getImage(img)}
                objectFit="contain"
                alt={img?.altText || ""}
              />
            </SwiperSlide>
          ))}

          <div className="sw-navigation">
            <ButtonEdgeRounded id={sliderId + "-nav-prev"} dir="start" />
            <ButtonEdgeRounded id={sliderId + "-nav-next"} dir="end" />
          </div>
        </Swiper>
        
        <TextModule
          title= {data?.contentSecondTitle}
          content = {data?.contentSecondContent}
          titleImage = {data?.contentSecondLogo}
          className={"py-md-7 pt-7 pb-3 text-module-logo"}
        />

        <div className="mobile-title-image ">
          <GatsbyImage
            className={`mb-7 mt-lg-2`}
            image={getImage(data?.contentSecondLogo)}
            objectFit={"contain"}
            alt={data?.contentSecondLogo?.altText || 'title image'}
          />
        </div>

        <div className="features mb-md-7 mb-9">
          {data?.features?.map((feature, index) => {
            return (
            <TextModule
              title= {feature?.featureTitle}
              content = {feature?.featureContent}
              className={"py-md-7 py-5"}
              key={index}
            />)
          })}
        </div>

        <CaseHistoryCarousel data={otherChildrenData} className="pt-md-7 mb-3 mb-md-7"/>
      </React.Suspense>
    </Layout>
  )
};

export default PageTemplate;

export const pageQuery = graphql`
query GET_TECHNOLOGY_PAGE ($eq: String!) { 
  lang: wpPage(slug: { eq: $eq }) {
    translations {
      postUrl
      siteId
    }
  }
  childPages: allWpPage(
    filter: {template: {templateName: {eq: "Parent Page Technology"}}}
  ) {
    nodes {
      wpChildren {
        nodes {
          ... on WpPage {
            title
            featuredImage {
              node {
                gatsbyImage(width: 500, aspectRatio: 1, formats: [AUTO, WEBP])
              }
            }
            uri
            acfPages_technology {
              backgroundColor
              relatedPageImage {
                gatsbyImage(width: 500, aspectRatio: 1, formats: [AUTO, WEBP])
              }
            }
            wpParent {
              node {
                ... on WpPage {
                  title
                }
              }
            }
          }
        }
      }
    }
  }
}
`
